export enum PhitoNotificationSubscriptionType {
    NONE = 'NONE',
    EMAIL = 'EMAIL',
    PUSH = 'PUSH',
    UI = 'UI',
}
